<template>
  <div class="tw-flex tw-flex-1 tw-flex-col">
    <slot />
  </div>
</template>
